export const myaccount = {
  button_update_account: "Update Account Info",
  button_payment_portal: "Open Payment Portal",
  button_update_plan: "Change Plan",
  button_start_new_plan: "Start New Subscription",
  button_update_payment_period: "Change Plan Payment Period",
  button_delete_account: "Delete Account",
  button_cancel_plan: "Cancel Subscription",

  my_account_head: "My Account",
  my_account:
    "Update account information, change payment plan, or access receipts, etc.",
  receipts_head: "My Receipts and Payment methods",
  receipts:
    "Access receipts, update credit card, etc on the Payment portal. Click button below. Onelink.to is using Stripe as payment provider.",

  delete_account_head: "Delete Account",
  delete_account:
    "By deleting your account any active subscription will be terminated immediately. There will be no reimbursements for remaining time on any active subscription. You are still required to pay any unpaid invoice still existing.",
  delete_account_step_2:
    "\n<strong>Information</strong>\nIf you delete your account, your information will be deleted or anonymized, unless we have a legally justifiable reason to keep it. E.g. if you at any point have had an subscription we are legally obligated to keep accounting data stored.\n\n<strong>Warning!</strong>\n • Any Onelink URL registered to the account will stop working.\n • This action <strong>can not</strong> be undone.\n",
  delete_confirm:
    "Confirm account deletion by writing <strong>DELETE</strong> in capital letters in the text input field below. Then proceed and press the <strong>Delete Account</strong> button below.",
  delete_confirm_label: "Write DELETE to confirm.",
  delete_confirm_error: "Write DELETE in capital letters to confirm.",

  cancel_plan_head: "Cancel Subscription",
  cancel_plan:
    "Cancel your active subscription. No new invoices will be created, but any existing unpaid invoices still have to be paid. All URLs registered to the account will still be active. After the end of the current payment period you will no longer be able to edit URLs or view statistics. You can at any time start a new subscription to access your URLs.",

  info_subscription_cancelled:
    "Your active subscription is cancelled. To keep access after current period has ended, start a new subscription.",
  subscription_cancelled_head: "Subscription Cancelled",
  transfer_legacy_head: "Transfer Old Onelinks",
  transfer_legacy_click_to_transfer:
    "Are you missing Onelinks from your account on our old platform?\nClick the button below to check if we can find any.",
  transfer_legacy_not_found: "We did not find any Onelinks to transfer.",
  transfer_legacy_transferred_template:
    "We found and transferred %s Onelinks.\n\nIf you don't see them immediately, please reload the site in a minute.",
  transfer_legacy_none_found: "We could not find any Onelinks to transfer.",
  button_legacy_transfer: "Transfer Onelinks",
};
